import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('selectDateFormatOption', function selectDateFormatOption(
    dateFormat: string
) {
    let optionState = getRegionalOptions();
    optionState.selectedDateFormat = dateFormat;
});
